// Release metadata helper.
//
// Build-time env vars (set via package.json `build` script and/or CI):
//   REACT_APP_RELEASE_ENV   — "prod" | "prerelease" | "local" | "unknown"
//   REACT_APP_BUILD_DATE    — ISO date, e.g. "2026-05-24"
//   REACT_APP_BUILD_TIME    — "HH:MM" (24h, build host local time)
//   REACT_APP_BUILD_NUMBER  — CI job/build id, e.g. "123"
//   REACT_APP_COMMIT_SHA    — short or full git SHA, e.g. "abc1234"
//
// Defensive defaults so a missing env var never breaks the build or footer.
const RAW_ENV = (process.env.REACT_APP_RELEASE_ENV || "").trim().toLowerCase();
const RAW_BUILD_DATE = (process.env.REACT_APP_BUILD_DATE || "").trim();
const RAW_BUILD_TIME = (process.env.REACT_APP_BUILD_TIME || "").trim();
const RAW_BUILD_NUMBER = (process.env.REACT_APP_BUILD_NUMBER || "").trim();
const RAW_COMMIT_SHA = (process.env.REACT_APP_COMMIT_SHA || "").trim();

function detectEnvironment() {
  if (RAW_ENV) {
    if (RAW_ENV === "prod" || RAW_ENV === "production") return "prod";
    if (RAW_ENV === "prerelease" || RAW_ENV === "uat" || RAW_ENV === "staging-uat") {
      return "prerelease";
    }
    if (RAW_ENV === "local" || RAW_ENV === "dev" || RAW_ENV === "development") {
      return "local";
    }
    return RAW_ENV;
  }
  if (process.env.NODE_ENV === "development") return "local";
  if (typeof window !== "undefined" && window.location && window.location.hostname) {
    const h = window.location.hostname;
    if (h === "localhost" || h === "127.0.0.1") return "local";
    // UAT host is windroos.boss-tech.nl per design document.
    if (h.includes("boss-tech") || h.includes("prerelease")) return "prerelease";
    if (h === "windroos.nl" || h.endsWith(".windroos.nl")) return "prod";
  }
  return "unknown";
}

const environment = detectEnvironment();
const buildDate = RAW_BUILD_DATE || null;
const buildTime = RAW_BUILD_TIME || null;
const buildNumber = RAW_BUILD_NUMBER || null;
const commitShaFull = RAW_COMMIT_SHA || null;
const commitShaShort = commitShaFull
  ? commitShaFull.slice(0, 7)
  : null;

export const releaseInfo = {
  version: "1.0.0",
  rc: "RC1",
  environment,
  buildDate,
  buildTime,
  buildNumber,
  commitShaShort,
  commitShaFull,
};

const ENV_LABELS = {
  prod: "Productie",
  prerelease: "Prerelease",
  local: "Lokaal",
  unknown: "Onbekend",
};

export function getReleaseEnvLabel() {
  return ENV_LABELS[environment] || environment;
}

// Short legacy label kept for backward compatibility with existing footers
// that show "Versie 1.0.0 · RC1".
export function getReleaseLabel() {
  return `Versie ${releaseInfo.version} · ${releaseInfo.rc}`;
}

// Extended one-line metadata, intended for subtle footer rendering.
// Example: "Prerelease · build 123 · 2026-05-24 09:58 · abc1234".
// Skips parts that are missing so it never renders empty separators.
export function getReleaseMetaLine() {
  const parts = [getReleaseEnvLabel()];
  if (buildNumber) parts.push(`build ${buildNumber}`);
  if (buildDate) {
    parts.push(buildTime ? `${buildDate} ${buildTime}` : buildDate);
  } else if (buildTime) {
    parts.push(buildTime);
  }
  if (commitShaShort) parts.push(commitShaShort);
  return parts.join(" · ");
}
